import { ComponentProps } from 'react';

import { Chip } from '@mui/material';

import { brlPercentual } from 'util/format';

type GerarReembolsoStatusChip = {
    idStatusApuracao: number;
    dsStatusApuracao: string;
    peProcessamento?: number;
};

const color: Record<number, ComponentProps<typeof Chip>['color']> = {
    1: 'info', // pendente
    2: 'warning', // aguardando
    3: 'info', // processando
    4: 'success', // finalizado com sucesso
    5: 'error', // finalizado com erro
} as const;

export function GerarReembolsoStatusChip({ idStatusApuracao, dsStatusApuracao, peProcessamento }: GerarReembolsoStatusChip) {
    let label = dsStatusApuracao;

    // 3 = Processando
    if (idStatusApuracao === 3 && peProcessamento !== undefined) {
        label = `${dsStatusApuracao} - ${brlPercentual(peProcessamento)}`;
    }

    return <Chip label={label} variant="outlined" size="small" color={color[idStatusApuracao]} sx={{ width: '100%' }} />;
}
